export default __webpack_public_path__ + "static/media/sie-intranet-white-rgb.2e9ebccc.svg";